const tables = [
  {
    name: "Name",
  },
  {
    name: "Number",
  },
  {
    name: "Task",
  },
  {
    name: "Issue Status",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
